import { useState, useEffect } from "react";
import {
  getCrmFirsatlar, addCrmFirsat, updateCrmFirsatAsama, deleteCrmFirsat, getCrmFirmalar, getCrmKisiler, getCrmPlasiyerler,
} from "../services/api";

const ASAMALAR = ["Lead", "Iletisimde", "Teklif", "Muzakere", "Kazanildi", "Kaybedildi"];
const ASAMA_RENK = {
  Lead: "#60a5fa", Iletisimde: "#a78bfa", Teklif: "#fbbf24",
  Muzakere: "#fb923c", Kazanildi: "#34d399", Kaybedildi: "#f87171",
};

const EMPTY_FORM = { firma_id: "", kisi_id: "", baslik: "", tutar: "", asama: "Lead", tahmini_kapanis_tarihi: "", sorumlu_kullanici: "" };

const fmt = (n) => n == null ? "-" : Number(n).toLocaleString("tr-TR", { minimumFractionDigits: 2 }) + " TL";

const card = { background: "var(--bg-card-alt)", border: "1px solid var(--accent-bg)", borderRadius: 10, padding: 20 };
const inp  = { background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "8px 11px", color: "var(--text-primary)", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
const btn  = (bg, color) => ({ background: bg, color, border: "none", borderRadius: 7, padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" });

export default function CrmFirsatlar() {
  const [firsatlar, setFirsatlar] = useState([]);
  const [firmalar, setFirmalar] = useState([]);
  const [kisiler, setKisiler] = useState([]);
  const [plasiyerler, setPlasiyerler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState(null);
  const [form, setForm] = useState(EMPTY_FORM);

  useEffect(() => {
    getCrmFirmalar().then((r) => setFirmalar(r.data)).catch(() => {});
    getCrmPlasiyerler().then((r) => setPlasiyerler(r.data)).catch(() => {});
    load();
  }, []);

  useEffect(() => {
    if (!form.firma_id) { setKisiler([]); return; }
    getCrmKisiler({ firma_id: form.firma_id }).then((r) => setKisiler(r.data)).catch(() => {});
  }, [form.firma_id]);

  async function load() {
    setLoading(true);
    try { setFirsatlar((await getCrmFirsatlar()).data); }
    catch { flash("Yuklenemedi", "error"); }
    finally { setLoading(false); }
  }

  function flash(text, type = "success") {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 4000);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.firma_id) { flash("Once bir firma secin", "error"); return; }
    try {
      await addCrmFirsat({
        ...form,
        firma_id: form.firma_id,
        kisi_id: form.kisi_id ? Number(form.kisi_id) : null,
        tutar: form.tutar ? parseFloat(form.tutar) : 0,
        tahmini_kapanis_tarihi: form.tahmini_kapanis_tarihi || null,
      });
      flash("Firsat eklendi");
      setForm(EMPTY_FORM);
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Hata", "error");
    }
  }

  async function handleAsamaChange(id, asama) {
    try {
      await updateCrmFirsatAsama(id, asama);
      load();
    } catch { flash("Guncellenemedi", "error"); }
  }

  async function handleDelete(id, baslik) {
    if (!window.confirm(`"${baslik}" silinsin mi?`)) return;
    try {
      await deleteCrmFirsat(id);
      flash("Silindi");
      load();
    } catch { flash("Silinemedi", "error"); }
  }

  const acikToplam = firsatlar
    .filter((f) => f.Asama !== "Kazanildi" && f.Asama !== "Kaybedildi")
    .reduce((s, f) => s + (f.Tutar || 0), 0);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>
      {msg && (
        <div style={{
          padding: "11px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
          background: msg.type === "error" ? "#3f1515" : "#0f3d20",
          border: `1px solid ${msg.type === "error" ? "#dc2626" : "#16a34a"}`,
          color: msg.type === "error" ? "#fca5a5" : "#86efac",
        }}>{msg.text}</div>
      )}

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--accent-text)", marginBottom: 16 }}>Yeni Firsat Ekle</div>
        <form onSubmit={handleSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 12, marginBottom: 14 }}>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>FIRMA</div>
              <select style={inp} value={form.firma_id} required
                onChange={(e) => setForm({ ...form, firma_id: e.target.value, kisi_id: "" })}>
                <option value="">Secin...</option>
                {firmalar.map((f) => <option key={f.CARI_KOD} value={f.CARI_KOD}>{f.Unvan}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>KISI</div>
              <select style={inp} value={form.kisi_id} onChange={(e) => setForm({ ...form, kisi_id: e.target.value })}>
                <option value="">Yok</option>
                {kisiler.map((k) => <option key={k.ID} value={k.ID}>{k.AdSoyad}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>BASLIK</div>
              <input style={inp} value={form.baslik} required
                onChange={(e) => setForm({ ...form, baslik: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>TUTAR (TL)</div>
              <input style={inp} type="number" step="0.01" value={form.tutar}
                onChange={(e) => setForm({ ...form, tutar: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>ASAMA</div>
              <select style={inp} value={form.asama} onChange={(e) => setForm({ ...form, asama: e.target.value })}>
                {ASAMALAR.map((a) => <option key={a} value={a}>{a}</option>)}
              </select>
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>TAHMINI KAPANIS</div>
              <input style={inp} type="date" value={form.tahmini_kapanis_tarihi}
                onChange={(e) => setForm({ ...form, tahmini_kapanis_tarihi: e.target.value })} />
            </div>
            <div>
              <div style={{ fontSize: 11, color: "var(--text-muted)", marginBottom: 5, fontWeight: 600 }}>SORUMLU</div>
              <select style={inp} value={form.sorumlu_kullanici}
                onChange={(e) => setForm({ ...form, sorumlu_kullanici: e.target.value })}>
                <option value="">Secilmedi</option>
                {plasiyerler.map((p) => <option key={p.PLASIYER_KODU} value={p.Ad}>{p.Ad}</option>)}
              </select>
            </div>
          </div>
          <button type="submit" style={btn("var(--accent)", "#fff")}>Firsat Ekle</button>
        </form>
      </div>

      <div style={{ ...card, padding: 16 }}>
        <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: ".05em" }}>Acik Pipeline Toplami</div>
        <div style={{ fontSize: 24, fontWeight: 700, color: "var(--text-primary)", marginTop: 6 }}>{fmt(acikToplam)}</div>
      </div>

      {loading ? (
        <div style={{ color: "var(--text-faint)", fontSize: 13, padding: 32, textAlign: "center" }}>Yukleniyor...</div>
      ) : (
        <div style={{ display: "grid", gridTemplateColumns: `repeat(${ASAMALAR.length},1fr)`, gap: 12, alignItems: "start" }}>
          {ASAMALAR.map((asama) => {
            const grup = firsatlar.filter((f) => f.Asama === asama);
            const toplam = grup.reduce((s, f) => s + (f.Tutar || 0), 0);
            return (
              <div key={asama} style={{ ...card, padding: 12, display: "flex", flexDirection: "column", gap: 8, minHeight: 200 }}>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 700, color: ASAMA_RENK[asama] }}>{asama}</div>
                  <div style={{ fontSize: 11, color: "var(--text-faint)" }}>{grup.length} firsat · {fmt(toplam)}</div>
                </div>
                {grup.map((f) => (
                  <div key={f.ID} style={{ background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 8, padding: 10, display: "flex", flexDirection: "column", gap: 6 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "var(--text-primary)" }}>{f.Baslik}</div>
                    <div style={{ fontSize: 11, color: "var(--text-secondary)" }}>{f.FirmaUnvani}</div>
                    {f.KisiAdi && <div style={{ fontSize: 11, color: "var(--text-faint)" }}>{f.KisiAdi}</div>}
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#34d399" }}>{fmt(f.Tutar)}</div>
                    {f.TahminiKapanisTarihi && (
                      <div style={{ fontSize: 11, color: "var(--text-faint)" }}>Kapanis: {String(f.TahminiKapanisTarihi).slice(0, 10)}</div>
                    )}
                    <select
                      value={f.Asama}
                      onChange={(e) => handleAsamaChange(f.ID, e.target.value)}
                      style={{ ...inp, padding: "4px 8px", fontSize: 11 }}
                    >
                      {ASAMALAR.map((a) => <option key={a} value={a}>{a}</option>)}
                    </select>
                    <button onClick={() => handleDelete(f.ID, f.Baslik)}
                      style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 6, padding: "4px 8px", fontSize: 11, cursor: "pointer" }}>
                      Sil
                    </button>
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
